import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=59159108&scoped=true&"
import script from "./Diagnostics.vue?vue&type=script&lang=js&"
export * from "./Diagnostics.vue?vue&type=script&lang=js&"
import style0 from "./Diagnostics.vue?vue&type=style&index=0&id=59159108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59159108",
  null
  
)

export default component.exports